/** @format */

/* eslint @typescript-eslint/prefer-nullish-coalescing: "warn" -- Legacy code: do not use as an example. */
import isPropValid from '@emotion/is-prop-valid';
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React, { Fragment, FunctionComponent } from 'react';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';

import { Product } from '@toucan/client/global/product';

import { styles } from './product-card-attributes.styles';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type AttributesProps = {
    /**
     * If a loading state should be displayed
     */
    isLoading?: boolean;

    /**
     * The product we are displaying
     */
    product?: Product;

    /**
     * How many attributes we are expecting the product to have
     */
    numExpectedAttributes: number;
};

const StyledAttributes = styled('ul').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const Attributes: FunctionComponent<AttributesProps> = ({
    isLoading,
    product,
    numExpectedAttributes,
}: AttributesProps) => {
    const { attributes } = product || {};

    /**
     * Don't render anything if there are no attributes
     */
    if (!attributes?.length && !isLoading) {
        return null;
    }

    const renderSkeleton = () => {
        return Array(numExpectedAttributes)
            .fill(null)
            .map(() => (
                <li key={uuid()}>
                    <Skeleton
                        variant={SkeletonVariant.TEXT}
                        data-testid="product-card__attributes__skeleton"
                    />
                </li>
            ));
    };

    const renderAttributes = () => {
        return (
            <Fragment>
                {attributes?.map(({ name, content }, index) => {
                    return (
                        // eslint-disable-next-line react/no-array-index-key -- Legacy code: do not use as an example.
                        <li key={`${name}-${index}`}>
                            <span
                                className="attribute-label"
                                data-testid="product-card__attributes__attribute-label"
                            >
                                {`${name}: `}
                            </span>
                            <span
                                className="attribute-value"
                                data-testid="product-card__attributes__attribute-value"
                            >
                                {content}
                            </span>
                        </li>
                    );
                })}
            </Fragment>
        );
    };

    return (
        <StyledAttributes>
            {isLoading ? renderSkeleton() : renderAttributes()}
        </StyledAttributes>
    );
};
